// Date stepping and the dispatch board URL.
// Day moves one day, week moves seven days, month moves one calendar month.
// The day of the month is kept when the target month is long enough, and
// shortened when it is not (31 January becomes 28 or 29 February).

const VIEWS = ['day', 'week', 'month'];

function formatDateKey(date) {
  const value = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(value.getTime())) return '';
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${value.getFullYear()}-${month}-${day}`;
}

function parseDateKey(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return date;
}

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function stepDate(date, view, direction) {
  const dir = Number(direction) < 0 ? -1 : 1;
  const current = startOfDay(date instanceof Date ? date : new Date());
  if (view === 'week') {
    current.setDate(current.getDate() + (7 * dir));
    return current;
  }
  if (view === 'month') {
    const day = current.getDate();
    const target = new Date(current.getFullYear(), current.getMonth() + dir, 1);
    const lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
    target.setDate(Math.min(day, lastDay));
    return target;
  }
  current.setDate(current.getDate() + dir);
  return current;
}

function normaliseView(value) {
  return VIEWS.includes(value) ? value : 'day';
}

function parseScheduleQuery(search) {
  const params = search instanceof URLSearchParams
    ? search
    : new URLSearchParams(typeof search === 'string' ? search : '');
  const parsed = parseDateKey(params.get('date'));
  return {
    date: parsed || startOfDay(new Date()),
    view: normaliseView(params.get('view')),
  };
}

function formatScheduleQuery(date, view) {
  const params = new URLSearchParams();
  params.set('date', formatDateKey(date));
  params.set('view', normaliseView(view));
  return params;
}

module.exports = {
  VIEWS,
  formatDateKey,
  formatScheduleQuery,
  normaliseView,
  parseDateKey,
  parseScheduleQuery,
  startOfDay,
  stepDate,
};
